import { atom } from "recoil";

export const AtomSelectedGeneration = atom({
    key: 'selectedGeneration',
    default: 6,
});